import * as React from 'react';

import {RangeInput} from '../../range-input/range-input';

import type {Plan} from '../types';

import {CUSTOM_PLAN_CODE} from './helpers';
import {PopoverContent} from './popover-content';

import styles from './add-on-picker-card-slider.module.css';

type Props = {
    plans: Plan[];
    selectedPlan: Plan;
    onSelectedPlanChange: (planCode: string) => void;
};

export function AddOnPickerSlider(props: Props) {
    const {plans, selectedPlan, onSelectedPlanChange} = props;

    const [isRequestingCustomPricing, setIsRequestingCustomPricing] =
        React.useState<boolean>(false);
    const [currentIndex, setCurrentIndex] = React.useState(props.plans.indexOf(props.selectedPlan));

    // @ts-expect-error
    const customRangeStart = plans[0].productQuantity.toLocaleString();

    const lastPlan = plans[plans.length - 1];
    // @ts-expect-error
    const lastPlanQuantity = lastPlan.productQuantity.toLocaleString();
    const customRangeEnd =
        // @ts-expect-error
        lastPlan.code === CUSTOM_PLAN_CODE ? `${lastPlanQuantity}+` : lastPlanQuantity;

    const handleContactOurTeam = () => {
        setIsRequestingCustomPricing(true);
        Nut.ajax.post({
            url: '/setup/billing/nutshell-marketing-contact.json',
        });
    };

    React.useEffect(() => {
        const plan = plans[currentIndex];
        // @ts-expect-error
        if (plan.code !== selectedPlan.code) {
            // @ts-expect-error
            onSelectedPlanChange(plan.code);
        }
    }, [currentIndex, plans, selectedPlan, onSelectedPlanChange]);

    return (
        <div className={styles.container}>
            <RangeInput
                min={0}
                max={props.plans.length - 1}
                customRange={{
                    start: customRangeStart,
                    end: customRangeEnd,
                }}
                value={currentIndex}
                onChange={setCurrentIndex}
                popoverValue={
                    // @ts-expect-error
                    <PopoverContent
                        selectedCode={props.selectedPlan.code}
                        quantity={props.selectedPlan.productQuantity.toLocaleString()}
                        productKey={props.selectedPlan.product}
                        requestingCustomPricing={isRequestingCustomPricing}
                        onClickContactOurTeam={handleContactOurTeam}
                    />
                }
                zIndex={9}
                disableFocusTrapZone={true}
            />
        </div>
    );
}
